import '../../style/base.css';



//////////////////
// WEBPACK FOOTER
// ./~/vant/es/form/style/index.js
// module id = 413
// module chunks = 0